export function isTeamMembership(membership) {
    return membership?.type === "team";
}
export function extendedMembershipToMembership(membership) {
    if (membership.type === "team") {
        return {
            type: "team",
            teamId: membership.teamId,
            role: membership.role,
        };
    }
    else {
        return {
            type: "organisation",
            role: membership.role,
            organisationId: membership.organisationId,
        };
    }
}
export function isExtendedTeamMembership(membership) {
    return membership?.type === "team";
}
export function isOrgMembership(membership) {
    return membership?.type === "organisation";
}
export function isExtendedOrgMembership(membership) {
    return membership?.type === "organisation";
}
//# sourceMappingURL=memberships.js.map